module.exports = __webpack_public_path__ + "static/media/html-css-javascript.07519ea4.jpg";